/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-screen-dialog-container .branch-details .mat-dialog-content{height:calc(100vh)!important;max-height:calc(100vh)!important}.table[_ngcontent-%COMP%]{height:400px;overflow-y:auto}.copy[_ngcontent-%COMP%]{display:inline-flex;vertical-align:middle;padding-left:10px;cursor:pointer}"];
export { styles as styles };
